module.exports = __webpack_public_path__ + "img/menu_btn.93f349bb.png";